import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom"; // pridaj tento import

export default function Contact() {
  const [error, setError] = useState("");
  const formRef = useRef(null);
  const currentYear = new Date().getFullYear();

  // Načítanie reCAPTCHA skriptu
  useEffect(() => {
    const script = document.createElement("script");
    // script.src = "https://www.google.com/recaptcha/api.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // Validácia pred odoslaním
  const handleSubmit = (e) => {
    setError("");
    const form = formRef.current;
    const name = form.name.value.trim();
    const email = form.email.value.trim();
    const year = form.year.value.trim();
    const message = form.message.value.trim();
    const recaptcha = window.grecaptcha?.getResponse();

    if (!name || !email || !year || !message) {
      setError("Všetky polia sú povinné.");
      e.preventDefault();
      return;
    }
    if (parseInt(year, 10) !== currentYear) {
      setError("Zadajte aktuálny rok.");
      e.preventDefault();
      return;
    }
    if (!recaptcha) {
      setError("Potvrďte, že nie ste robot (reCAPTCHA).");
      e.preventDefault();
      return;
    }
  };

  return (
    <section className="contact-section">
      <h2>Kontaktujte nás</h2>
      {/* Odkaz na domovskú stránku */}
      <div style={{ marginBottom: "1rem" }}>
        <Link to="/">Domov</Link>
      </div>
      {error && <div style={{ color: "red", marginBottom: "1rem" }}>{error}</div>}
      <form
        ref={formRef}
        action="/mailform.php"
        method="POST"
        className="contact-form"
        onSubmit={handleSubmit}
      >
        <label>
          Vaše meno
          <input type="text" name="name" required />
        </label>
        <label>
          Váš email
          <input type="email" name="email" required />
        </label>
        <label>
          Aktuálny rok
          <input type="number" name="year" placeholder={currentYear} required />
        </label>
        <label>
          Správa
          <textarea name="message" rows="5" required />
        </label>
        {/* Google reCAPTCHA */}
        <div className="g-recaptcha" data-sitekey="6Ledw9AqAAAAAH2dEKYk4cnoXPHsMm-m5evZuRgB"></div>
        <button type="submit">Odoslať</button>
      </form>
    </section>
  );
}